import object from 'common/helpers/primitives/object'
import useLifecycle from './useLifecycle'


/**
 * @param {Object} state
 * @param {String} [title]
 * @param {String} [url]
 */
const useHistoryUpdate = (state, title, url) => (
  useLifecycle((isFirstRender) => {
    const currentState  = object.get(window, 'history.state', {})
    const isChanged     = Object.keys(state).some((key) => state[key] !== currentState[key])

    if (isChanged) {
      const eventType = isFirstRender ? 'replaceState' : 'pushState'

      window.history[eventType](
        state,
        title || document.title,
        url || window.location.href,
      )
    }
  }, [ state, title, url ])
)


export default useHistoryUpdate
